import Vue from "vue";
import "chartist/dist/chartist.min.css";
import "chartist-plugin-tooltips/dist/chartist-plugin-tooltip.min";
import "chartist-plugin-tooltips/dist/chartist-plugin-tooltip.css";
Vue.use(require("vue-chartist"));
